<template>
  <div :class="{ seen: seen }" class="notifications__list-item" @click="toLink">
    <div class="count" aria-label="Count">
      <span>{{ notificationCount }}</span>
    </div>
    <div class="body">
      <p v-html="notification.content" />
      <p class="time">
        {{ timeLeft }}
      </p>
    </div>
  </div>
</template>
<script>
import getTimeDiff from "@/utils/time/getTimeDiff";
import { authStore } from "@/mixins/authStoreMixin";

export default {
  name: "VNotificationListItem",

  props: {
    notification: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    seen() {
      return this.notification.unreadedCount === 0;
    },
    notificationCount() {
      const sum =
        this.notification.readedCount + this.notification.unreadedCount;
      return sum > 99 ? "99+" : sum;
    },
    timeLeft() {
      return getTimeDiff(Date.now(), this.notification.updatedAt, false, true);
    }
  },

  methods: {
    toLink() {
      this.$store.dispatch(
        `${authStore.moduleName}/${authStore.actionTypes.ACTION_READ_NOTIFICAITON}`,
        this.notification
      );

      if (this.notification.url) {
        const route = this.$router.resolve(this.notification.url)
        if (route && route.route.matched.length > 0) {
          this.$router.push({ path: this.notification.url })
        }
      }
    }
  }
};
</script>
